import { render } from "./famousCourseUploadVideo.vue?vue&type=template&id=0d2d5985&scoped=true"
import script from "./famousCourseUploadVideo.vue?vue&type=script&lang=js"
export * from "./famousCourseUploadVideo.vue?vue&type=script&lang=js"

import "./famousCourseUploadVideo.vue?vue&type=style&index=0&id=0d2d5985&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2d5985"]])

export default __exports__